module.exports = __webpack_public_path__ + "img/d70f759.jpg";